// Authentication Pages

export default [ 
  {
    params: {
      path: "/auth/login",
      name: "auth/Login",
      meta: { 
        layout: "auth",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Auth/Login/Login",
  },
  {
    params: {
      path: "/auth/logout",
      name: "auth/Logout",
      meta: { 
        layout: "auth",
        requiresAuth: true
      },
    },
    defaultComponentPath: "Auth/Logout/Logout",
  },
  {
    params: {
      path: "/auth/forgotpassword",
      name: "auth/ForgotPassword",
      meta: { 
        layout: "auth",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Auth/ForgotPassword/ForgotPassword",
  },
  {
    params: {
      path: "/auth/signup",
      name: "auth/Signup",
      meta: { 
        layout: "auth",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Auth/Signup/Signup",
  },
  {
    params: {
      path: "/auth/signup_agent",
      name: "auth/Signup_agent",
      meta: { 
        layout: "auth",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Auth/Signup/Signup_Agent",
  },
  {
    params: {
      path: "/auth/lockscreen",
      name: "auth/LockScreen",
      meta: { 
        layout: "auth",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Auth/LockScreen/LockScreen",
  },
  {
    params: {
      path: "/auth/bind",
      name: "auth/Bind",
      meta: { 
        layout: "auth",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Auth/Bind/Bind",
  },  
  {
    params: {
      path: "/auth/storageissue",
      name: "auth/StorageIssue",
      meta: { 
        layout: "auth",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Auth/StorageIssue/StorageIssue",
  },
  {
    params: {
      path: "/dv",
      name: "Dev",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Dev/Dev",
    navs: false,
  },
  {
    params: {
      path: "/db",
      name: "Dbg",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Dev/Dbg",
    navs: false,
  },     
  {
    params: {
      path: "/account",
      name: "Account",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Account/Account",
    navs: true,
  },
  {
    params: {
      path: "/booking",
      name: "Booking",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Booking/Booking",
    navs: true,
  },
  {
    params: {
      path: "/",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/ai",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: true,
  },
  {
    params: {
      path: "/st",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper",
    navs: false,
  }, 
  {
    params: {
      path: "/sd",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },  
  {
    params: {
      path: "/we",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/db",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },    
  {
    params: {
      path: "/wa",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/go",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/mk",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/vm",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/fb",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/ig",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/tw",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/li",
      name: "DirectBooking",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/DB_stepper_desktop",
    navs: false,
  },
  {
    params: {
      path: "/error",
      name: "Error",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/ErrorDB",
    navs: false,
  },         
  {
    params: {
      path: "/unknown",
      name: "Unknown",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Booking/Unknown",
    navs: false,
  },  
  {
    params: {
      path: "/validateqr",
      name: "ValidateQR",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Review/ValidateQR",
    navs: false,
  }, 
  {
    params: {
      path: "/coupon",
      name: "Coupon",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Review/ShowCoupon",
    navs: false,
  },   
  {
    params: {
      path: "/review",
      name: "Review",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Review/Review",
    navs: false,
  },
  {
    params: {
      path: "/reviews",
      name: "Reviews",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Review/Reviews",
    navs: true,
  },    
  {
    params: {
      path: "/forward",
      name: "Forward",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Forward/Forward",
    navs: false,
  },  
  {
    params: {
      path: "/manager",
      name: "manage",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Manage/Manage",
    navs: true,
  },
  {
    params: {
      path: "/manage250311",
      name: "manage",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Manage/Manage250311",
    navs: true,
  },  
  {
    params: {
      path: "/agenda",
      name: "agenda",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Manage/Agenda",
    navs: true,
  }, 
  {
    params: {
      path: "/mktg",
      name: "mktg",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "MKTG/Marketing",
    navs: true,
  },
  {
    params: {
      path: "/uu",
      name: "uu",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "MKTG/U",
    navs: true,
  }, 
  {
    params: {
      path: "/manage_grid",
      name: "manage_grid",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Manage/Manage_grid",
    navs: true,
  }, 
  {
    params: {
      path: "/manage_map",
      name: "manage_map",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Manage/Manage_map",
    navs: true,
  }, 
  {
    params: {
      path: "/pdf",
      name: "pdf",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "PDF/pdf",
    navs: true,
  },      
  {
    params: {
      path: "/canvas",
      name: "canvas",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Canvas/CanvasHall",
    navs: true,
  }, 
  {
    params: {
      path: "/canvas_out",
      name: "canvas:out",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Canvas/v6/CanvasOut",
    navs: true,
  },    
  {
    params: {
      path: "/canvas_out_latest",
      name: "canvas_out_latest",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Canvas/v6/CanvasOut_latest",
    navs: true,
  },
  {
    params: {
      path: "/canvas_out2",
      name: "canvas_out2",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Canvas/v6/CanvasOut2",
    navs: true,
  },        
  {
    params: {
      path: "/pbx",
      name: "PBX",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "PBX/PBX",
    navs: true,
  },
  /*
  {
    params: {
      path: "/voicemail",
      name: "VoiceMail",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "VoiceMail/VoiceMail",
    navs: true,
  },
  */  
  {
    params: {
      path: "/waitinglist",
      name: "WaitingList",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "WaitingList/WaitingList",
    navs: true,
  },      
  {
    params: {
      path: "/kitchen",
      name: "Kitchen",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Manage/Kitchen",
    navs: true,
  },
  {
    params: {
      path: "/university",
      name: "University",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "University/University",
    navs: true,
  },      
  {
    params: {
      path: "/deposits",
      name: "Deposits",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Deposits/Deposits",
    navs: true,
  },
  {
    params: {
      path: "/settings",
      name: "Settings",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Settings/Settings",
    navs: true,
  },
  {
    params: {
      path: "/stats",
      name: "Stats",
      meta: {
        requiresAuth: true,
        bossOnly : false
      }
    },
    defaultComponentPath: "Stats/Stats",
    navs: true,
  },
  {
    params: {
      path: "/businessreport",
      name: "BusinessReport",
      meta: {
        requiresAuth: true,
        bossOnly : true
      }
    },
    defaultComponentPath: "BusinessReport/BusinessReport",
    navs: true,
  },
  {
    params: {
      path: "/whatsapp",
      name: "WhatsApp",
      meta: {
        requiresAuth: true,
      }
    },
    defaultComponentPath: "WhatsApp/WhatsApp",
    navs: true,
  },  
  {
    params: {
      path: "/shop",
      name: "Shop",
      meta: {
        requiresAuth: true,
        bossOnly : true
      }
    },
    defaultComponentPath: "Shop/Shop",
    navs: true,
  },
  {
    params: {
      path: "/payments",
      name: "Payments",
      meta: {
        requiresAuth: true,
        bossOnly : false
      }
    },
    defaultComponentPath: "Payments/Payments",
    navs: true,
  }, 
  {
    params: {
      path: "/customers",
      name: "Customers",
      meta: {
        requiresAuth: true,
        bossOnly : true
      }
    },
    defaultComponentPath: "Customers/Customers",
    navs: true,
  },
  {
    params: {
      path: "/university/admin",
      name: "University Admin",
      meta: {
        requiresAuth: true,
        bossOnly : true
      }
    },
    defaultComponentPath: "University/Admin",
    navs: true,
  },    
  {
    params: {
      path: "/tasks",
      name: "Tasks",
      meta: {
        requiresAuth: true,
      }
    },
    defaultComponentPath: "Tasks/Tasks",
    navs: true,
  },
  {
    params: {
      path: "/tasks/calendar",
      name: "Calendar",
      meta: {
        requiresAuth: true,
      }
    },
    defaultComponentPath: "Tasks/Calendar",
    navs: true,
  },
  {
    params: {
      path: "/tasks/orders",
      name: "Orders",
      meta: {
        requiresAuth: true,
      }
    },
    defaultComponentPath: "Tasks/Orders",
    navs: true,
  },
  {
    params: {
      path: "/tasks/settings",
      name: "Settings",
      meta: {
        requiresAuth: true,
      }
    },
    defaultComponentPath: "Tasks/Settings",
    navs: true,
  },
  {
    params: {
      path: "/messages",
      name: "Messages",
      meta: {
        requiresAuth: true
      }
    },
    defaultComponentPath: "Messages/Messages",
    navs: true,
  },
  {
    params: {
      path: "/tos",
      name: "Tos",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Tos/Tos",
    unsignednavs: true,
  },
  {
    params: {
      path: "/privacy",
      name: "Privacy",
      meta: {
        requiresAuth: false
      }
    },
    defaultComponentPath: "Privacy/Privacy",
    unsignednavs: true,
  },
  {
    params: {
      path: "/boss/dashboard",
      name: "boss/dashboard",
      meta: { 
        layout: "full",
        requiresAuth: true,
        bossOnly : true
      },
    },
    defaultComponentPath: "Boss/Dashboard/Dashboard",
    bossnavs: true,
  },
  {
    params: {
      path: "/boss/users",
      name: "boss/users",
      meta: { 
        requiresAuth: true,
        bossOnly : true
      },
    },
    defaultComponentPath: "Boss/Users",
    bossnavs: true,
  },
  {
    params: {
      path: "/boss/invoiceData",
      name: "boss/invoiceData",
      meta: { 
        requiresAuth: true,
        bossOnly : true
      },
    },
    defaultComponentPath: "Boss/invoiceData",
    bossnavs: true,
  },  
  {
    params: {
      path: "/boss/campaigns",
      name: "boss/campaigns",
      meta: { 
        requiresAuth: true,
        bossOnly : true
      },
    },
    defaultComponentPath: "Boss/Campaigns",
    bossnavs: true,
  },  
  {
    params: {
      path: "/boss/tickets",
      name: "boss/tickets",
      meta: { 
        requiresAuth: true,
        bossOnly : true
      },
    },
    defaultComponentPath: "Boss/Tickets/Tickets",
    bossnavs: true,
  },
  {
    params: {
      path: "/boss/settings",
      name: "boss/settings",
      meta: { 
        requiresAuth: true,
        bossOnly : true
      },
    },
    defaultComponentPath: "Boss/Settings",
    bossnavs: true,
  },
  {
    params: {
      path: "/boss/team",
      name: "boss/team",
      meta: { 
        requiresAuth: true,
        bossOnly : true
      },
    },
    defaultComponentPath: "Boss/team",
    bossnavs: true,
  },  
  {
    params: {
      path: "/boss/stripe",
      name: "boss/stripe",
      meta: { 
        requiresAuth: true,
        bossOnly : true
      },
    },
    defaultComponentPath: "Boss/Stripe",
    bossnavs: true,
  },
  {
    params: {
      path: "/boss/booking-translations",
      name: "boss/booking-translations",
      meta: {
        requiresAuth: true,
        bossOnly: true,
      },
    },
    defaultComponentPath: "Boss/BookingTranslations",
    bossnavs: true,
  },
  {
    params: {
      path: "/comingsoon",
      name: "ComingSoon",
      meta: { 
        layout: "full",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Pages/ComingSoon",
  },

  {
    params: {
      path: "/error/404",
      name: "error/Error404",
      meta: { 
        layout: "full",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Errors/Error404",
  },
  {
    params: {
      path: "/error/401",
      name: "error/Error401",
      meta: { 
        layout: "full",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Errors/Error401",
  },
  {
    params: {
      path: "/error/403",
      name: "/error/Error403",
      meta: { 
        layout: "full",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Errors/Error403",
  },
  {
    params: {
      path: "/error/500",
      name: "error/Error500",
      meta: { 
        layout: "full",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Errors/Error500",
  },
  {
    params: {
      path: "/error/503",
      name: "error/Error503",
      meta: { 
        layout: "full",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Errors/Error503",
  },

  {
    params: {
      path: "*",
      name: "PageNotFound",
      meta: { 
        layout: "full",
        requiresAuth: false
      },
    },
    defaultComponentPath: "Errors/Error404",
  },
];
